export const getPageType = (mergeSimilar?: boolean) => {
  const productMerge = ['product', 'product_bundle', 'product_non_food'];

  // Gets pageType from the last pageView event in the dataLayer
  if (typeof window !== 'undefined') {
    const dlName = process.env.GATSBY_DATA_LAYER_NAME ?? '';

    const lastPageView: {
      event: string;
      event_params: {
        page_path: string;
        page_type: string;
      };
    } = window[dlName]?.findLast((item: any) => item.event === 'page_view');
    const pagetype = lastPageView?.event_params?.page_type?.replace('node__', '');
    const exists = Boolean(lastPageView?.event_params?.page_type);

    if (mergeSimilar && exists) {
      if (productMerge.includes(pagetype)) {
        return 'pdp';
      }
    }

    if (exists) {
      return pagetype;
    }
  }

  // A fallback encase what should always happen for some reason doesn't.
  if (typeof document !== 'undefined') {
    const main = document.getElementById('page-type-setter');
    const pageType = main?.getAttribute('data-page-type')?.replace('node__', '');

    if (mergeSimilar && pageType) {
      if (productMerge.includes(pageType)) {
        return 'pdp';
      }
    }

    return pageType;
  }

  return '[not set]';
};

export const filterKey = (obj: Object, keyToRemove: string) =>
  Object.fromEntries(Object.entries(obj).filter(([key]) => key !== keyToRemove));
